import React, { Fragment } from "react"
import { RouteComponentProps } from "@reach/router"
import { Navigation } from "../../components"
import styles from "./Building.scss"

const BuildingPage = ({  }: RouteComponentProps) => (
  <Fragment>
    <Navigation animated={false} />
    <div className={styles.maintenanceContainer}>
      Allez Go !<br />
      Page en construction
    </div>
  </Fragment>
)

export default BuildingPage
